import { render, staticRenderFns } from "./EventTypeFieldSetting.vue?vue&type=template&id=38865c02"
import script from "./EventTypeFieldSetting.vue?vue&type=script&lang=js"
export * from "./EventTypeFieldSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports